import React from 'react';
import { Building2, LogOut, RefreshCw, Settings } from 'lucide-react';
import { useAuth } from '../../providers/AuthProvider';
import { usePermissions } from '../../hooks/usePermissions';

interface HeaderProps {
	onRefresh: () => void;
	isRefreshing?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ onRefresh, isRefreshing }) => {
	const { user, logout } = useAuth();
	const { isClientUser, clientName, roleDisplayName } = usePermissions();

	return (
		<div className="bg-gray-50 border-b border-gray-200">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex items-center justify-between h-16">
					<div className="flex items-center space-x-4">
						<div className="h-8 w-8 bg-blue-600 rounded-lg flex items-center justify-center">
							{isClientUser ? (
								<Building2 className="h-5 w-5 text-white" />
							) : (
								<Settings className="h-5 w-5 text-white" />
							)}
						</div>
						<h1 className="text-xl font-semibold text-gray-900">
							{isClientUser ? (
								<>
									{clientName || 'Client'} <span className="text-gray-500 font-normal">· Powered by Mergeo.ai</span>
								</>
							) : (
								'Mergeo.ai Admin Dashboard'
							)}
						</h1>
					</div>

					<div className="flex items-center space-x-4">
						{/* Client Context Badge for CLIENT_USER */}
						{isClientUser && clientName && (
							<div className="flex items-center space-x-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg">
								<Building2 className="h-4 w-4 text-blue-600" />
								<span className="text-sm font-medium text-blue-900">{clientName}</span>
							</div>
						)}

						<button
							onClick={onRefresh}
							disabled={isRefreshing}
							className="p-2 text-gray-400 hover:text-gray-600 disabled:opacity-50">
							<RefreshCw className={`h-5 w-5 ${isRefreshing ? 'animate-spin' : ''}`} />
						</button>

						<div className="flex items-center space-x-3">
							<div className="text-right">
								<p className="text-sm font-medium text-gray-900">
									{user?.firstName} {user?.lastName}
								</p>
								<p className="text-xs text-gray-500">{roleDisplayName}</p>
							</div>
							<button onClick={logout} className="p-2 text-gray-400 hover:text-gray-600">
								<LogOut className="h-5 w-5" />
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
